import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import {default as deviceActions} from '../devices/actions'
import { updateLocation } from '../../../api/devices/devices.api';
import { SERVER_ERRORS } from '../../../api/SERVER_ERRORS';
import notifications from '../notification/actions';

const {fetchDevices} = deviceActions

function* updateLocationSaga(action) {
    try {
        const response = yield call(updateLocation, action.payload);
        if (response.updated && response.updated === "OK") {

            yield put(notifications.createNotification({
                message: "updated Successfully",
                status: 'SUCCESS'
            }));
        }else {
            yield put(notifications.createNotification({
                code: SERVER_ERRORS.COULD_NOT_UPDATE_CLIENT,
                mainAction: actions.UPDATE_LOCATION_ERROR,
            }));
        }
        if(action.payload.fetchDevicesPayload){
            yield put(fetchDevices(action.payload.fetchDevicesPayload))
        }
            
    } catch (error) {
        yield put(notifications.createNotification({
            mainAction: actions.UPDATE_LOCATION_ERROR,
            code: SERVER_ERRORS.UNKNOWN_SERVER_ERROR
        }));
    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.UPDATE_LOCATION, updateLocationSaga),
    ]);
}